import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { ApiService } from './api.service';
import { GetSecretesPhraseQuery } from '../../../API';
import { GetSecretesPhrase } from '../../../graphql/queries';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  constructor(private apiService: ApiService) {}

  encryptSecret(secret: string): Promise<string> {
    return this.apiService
      .query<GetSecretesPhraseQuery>(GetSecretesPhrase)
      .then((response) => {
        if (response.data) {
          const encrypted = CryptoJS.AES.encrypt(secret, response.data.GetSecretesPhrase!).toString();
          return encrypted;
        } else {
          throw Error('No secret passphrase found');
        }
      })
      .catch((error) => {
        throw error;
      });
  }

  decryptSecret(encryptedSecret: string): Promise<string> {
    return this.apiService
      .query<GetSecretesPhraseQuery>(GetSecretesPhrase)
      .then((response) => {
        if (response.data) {
          const bytes = CryptoJS.AES.decrypt(encryptedSecret, response.data.GetSecretesPhrase!);
          return bytes.toString(CryptoJS.enc.Utf8);
        } else {
          throw Error('No secret passphrase found');
        }
      })
      .catch((error) => {
        throw error;
      });
  }
}
